import { render, staticRenderFns } from "./DenyEmail.vue?vue&type=template&id=81f3c148&scoped=true&"
import script from "./DenyEmail.vue?vue&type=script&lang=js&"
export * from "./DenyEmail.vue?vue&type=script&lang=js&"
import style0 from "./DenyEmail.vue?vue&type=style&index=0&id=81f3c148&prod&lang=scss&"
import style1 from "./DenyEmail.vue?vue&type=style&index=1&id=81f3c148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f3c148",
  null
  
)

export default component.exports